import React from 'react';
import { Store } from '../../../store';
import { BonusPoints } from '../../BonusPoints';
import { PageableList } from '@hugendubel/ws_client';
import { ArticleListEntryView } from './ArticleListEntryView';
import { __ } from 'first-intl';
import { ReducedProduct } from '../../../ws/result/ReducedProduct';

type ArticleListStoreProps = { points: BonusPoints; articles: PageableList<ReducedProduct> | null };
type ArticleListOwnProps = Record<string, unknown>;
export type ArticleListProps = ArticleListStoreProps & ArticleListOwnProps;

export const UnconnectedArticleList: React.FC<ArticleListProps> = ({ points, articles }) => {
    const items = articles && articles.items;
    if (!items || !items.length)
        return (
            <div className="error">
                {__(process.env.IS_HUDU ? 'page.Home.no.articles.hudu' : 'page.Home.no.articles.eBook')}
            </div>
        );

    return (
        <div className="row article-list">
            {items.map((article: ReducedProduct) => (
                <ArticleListEntryView article={article} points={points} key={article.articleId} />
            ))}
        </div>
    );
};

export const ArticleList = Store.wire<ArticleListStoreProps, ArticleListOwnProps>(
    UnconnectedArticleList,
    ({ points, articles }) => ({ points, articles })
);
